// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { StructuredAssetsSubform_AccountFragment } from '../../../entities/StructuredAssetsSubform/graphql/StructuredAssetsSubform.generated';
import { gql } from '@apollo/client';
import { StructuredAssetsSubform_AccountFragmentDoc } from '../../../entities/StructuredAssetsSubform/graphql/StructuredAssetsSubform.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FullScreenStructuredAssetsModal_EntityFragment = { __typename?: 'Entity', id: string, stage: Types.EntityStage, addeparLinkedToNongrantorEntity?: boolean | null, liquidityStatus: Types.EntityLiquidityStatus, showEntityNameOnBalanceSheet: boolean, groupIntegrationAssetValues: boolean, pauseIntegrationSync: boolean, balanceSheetCategoryOverride?: { __typename?: 'BalanceSheetCategory', id: string } | null, integrationEntities?: Array<{ __typename?: 'IntegrationEntity', id: string, kind: Types.IntegrationEntityKind, name: string }> | null, subtype: { __typename?: 'CCorpBusinessEntity', enableRealTppTaxExposure?: boolean | null, id: string, taxDiscount?: Percent | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'CLTTrust', id: string, taxDiscount?: Percent | null, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'CRTTrust', id: string, taxDiscount?: Percent | null, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'CustodialPersonalAccount', id: string, taxDiscount?: Percent | null, owner?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null } | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'DonorAdvisedFund', id: string, taxDiscount?: Percent | null, donors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'GPBusinessEntity', enableRealTppTaxExposure?: boolean | null, id: string, taxDiscount?: Percent | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'GRATTrust', id: string, taxDiscount?: Percent | null, grantor?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null } | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'ILITTrust', id: string, taxDiscount?: Percent | null, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'IndividualPersonalAccount', id: string, taxDiscount?: Percent | null, owner?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null } | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'InsurancePersonalAccount', id: string, taxDiscount?: Percent | null, owners?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'IrrevocableTrust', id: string, taxDiscount?: Percent | null, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'JointPersonalAccount', id: string, taxDiscount?: Percent | null, owners?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'LLCBusinessEntity', enableRealTppTaxExposure?: boolean | null, id: string, taxDiscount?: Percent | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'LPBusinessEntity', enableRealTppTaxExposure?: boolean | null, id: string, taxDiscount?: Percent | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'PrivateFoundation', id: string, taxDiscount?: Percent | null, donors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'QPRTTrust', id: string, taxDiscount?: Percent | null, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, taxDiscount?: Percent | null, owner?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null } | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'RetirementPersonalAccount', id: string, taxDiscount?: Percent | null, owner?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null } | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'RevocableTrust', id: string, taxDiscount?: Percent | null, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'SCorpBusinessEntity', enableRealTppTaxExposure?: boolean | null, id: string, taxDiscount?: Percent | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'SLATTrust', id: string, taxDiscount?: Percent | null, grantor?: { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null } | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'SoleProprietorshipBusinessEntity', enableRealTppTaxExposure?: boolean | null, id: string, taxDiscount?: Percent | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } };

export type FullScreenStructuredAssetsModalQueryVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
}>;


export type FullScreenStructuredAssetsModalQuery = { __typename?: 'Query', node?: { __typename?: 'AISuggestion' } | { __typename?: 'AISuggestionEvidence' } | { __typename?: 'AccessAgeParameter' } | { __typename?: 'AccessParameter' } | { __typename?: 'Account' } | { __typename?: 'ActiveEstateInsightsPage' } | { __typename?: 'Activity' } | { __typename?: 'Address' } | { __typename?: 'Answer' } | { __typename?: 'AnswerEvidence' } | { __typename?: 'AnswerRevision' } | { __typename?: 'Approval' } | { __typename?: 'AssetClass' } | { __typename?: 'AssetGroup' } | { __typename?: 'AssetStatic' } | { __typename?: 'AssetV2' } | { __typename?: 'AssetValuationV2' } | { __typename?: 'AssetValueV2' } | { __typename?: 'AsyncJob' } | { __typename?: 'BalanceSheetBundleConfiguration' } | { __typename?: 'BalanceSheetCategory' } | { __typename?: 'BalanceSheetViewConfiguration' } | { __typename?: 'BeneficiariesBundleConfiguration' } | { __typename?: 'BeneficiariesTemplateBundleConfiguration' } | { __typename?: 'Beneficiary' } | { __typename?: 'BeneficiaryAccessParameter' } | { __typename?: 'BeneficiaryDesignationGroup' } | { __typename?: 'BeneficiaryDistribution' } | { __typename?: 'BeneficiaryDistributionParameter' } | { __typename?: 'BeneficiaryPage' } | { __typename?: 'BeneficiaryPowerOfAppointment' } | { __typename?: 'CCorpBusinessEntity' } | { __typename?: 'CLTProposal' } | { __typename?: 'CLTTrust' } | { __typename?: 'CRTProposal' } | { __typename?: 'CRTTrust' } | { __typename?: 'Capability' } | { __typename?: 'Cashflow' } | { __typename?: 'ClientOrganization' } | { __typename?: 'ClientPresentationV2' } | { __typename?: 'ClientProfile' } | { __typename?: 'ClientProfileRelationship' } | { __typename?: 'Collaborator' } | { __typename?: 'ComparedWaterfall' } | { __typename?: 'CompletedEstateInsightsPage' } | { __typename?: 'ControllingParty' } | { __typename?: 'Conversation' } | { __typename?: 'CoverPageConfiguration' } | { __typename?: 'CustodialPersonalAccount' } | { __typename?: 'DSUEPortability' } | { __typename?: 'DiagramArtifact' } | { __typename?: 'DiagramArtifactPrompt' } | { __typename?: 'DispositionScenario' } | { __typename?: 'DispositiveProvision' } | { __typename?: 'DispositiveProvisionTemplate' } | { __typename?: 'DividerBundleConfiguration' } | { __typename?: 'DividerTemplateBundleConfiguration' } | { __typename?: 'Document' } | { __typename?: 'DocumentQuestion' } | { __typename?: 'DocumentQuestionAnswers' } | { __typename?: 'DocumentSummary' } | { __typename?: 'DocumentSummaryPage' } | { __typename?: 'DocumentSummaryPrompt' } | { __typename?: 'DocumentSummaryPromptTestRun' } | { __typename?: 'DocumentSummaryTemplateBundleConfiguration' } | { __typename?: 'DonorAdvisedFund' } | { __typename?: 'Employee' } | { __typename?: 'EntitiesOverviewBundleConfiguration' } | { __typename?: 'EntitiesOverviewBundleConfigurationEntity' } | (
    { __typename?: 'Entity' }
    & FullScreenStructuredAssetsModal_EntityFragment
  ) | { __typename?: 'EntityDiagram' } | { __typename?: 'EntityDocumentRelationship' } | { __typename?: 'EntityGraphView' } | { __typename?: 'EntityGraphViewBundleConfiguration' } | { __typename?: 'EntityNotes' } | { __typename?: 'EntityProposal' } | { __typename?: 'EntitySummaryBundleConfiguration' } | { __typename?: 'EntitySummaryTemplateBundleConfiguration' } | { __typename?: 'EntityTask' } | { __typename?: 'EntityTaxInfo' } | { __typename?: 'EstateInsight' } | { __typename?: 'EstateInsightReference' } | { __typename?: 'EstateInsightsBundleConfiguration' } | { __typename?: 'EstateTaxScenario' } | { __typename?: 'EstateWaterfall' } | { __typename?: 'EstateWaterfallHypotheticalStateChange' } | { __typename?: 'EstateWaterfallHypotheticalTransfer' } | { __typename?: 'EstateWaterfallMessageContext' } | { __typename?: 'EstateWaterfallVisualizationConfig' } | { __typename?: 'EstateWaterfallVisualizationFilter' } | { __typename?: 'FamilyTreeBundleConfiguration' } | { __typename?: 'FamilyTreeConfiguration' } | { __typename?: 'FeatureFlag' } | { __typename?: 'FeatureFlagQueryRule' } | { __typename?: 'File' } | { __typename?: 'FilePage' } | { __typename?: 'FileParagraph' } | { __typename?: 'Form' } | { __typename?: 'FormVersion' } | { __typename?: 'GPBusinessEntity' } | { __typename?: 'GRATAnnuityV2' } | { __typename?: 'GRATProposalScenario' } | { __typename?: 'GRATTrust' } | { __typename?: 'GiftingProposal' } | { __typename?: 'GiftingProposalCashFlow' } | { __typename?: 'GiftingProposalGift' } | { __typename?: 'GiftingProposalGiftSender' } | { __typename?: 'GiftingProposalPortfolio' } | { __typename?: 'GiftingProposalScenario' } | { __typename?: 'GraphVisualizationGroup' } | { __typename?: 'GrowthProfile' } | { __typename?: 'GrowthProfileOverride' } | { __typename?: 'Household' } | { __typename?: 'HypotheticalCLT' } | { __typename?: 'HypotheticalCRT' } | { __typename?: 'HypotheticalGRAT' } | { __typename?: 'HypotheticalInsurance' } | { __typename?: 'HypotheticalSaleLoan' } | { __typename?: 'HypotheticalTransferAsset' } | { __typename?: 'HypotheticalTransferFundingSource' } | { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' } | { __typename?: 'ILITCrummeyLetter' } | { __typename?: 'ILITTrust' } | { __typename?: 'Image' } | { __typename?: 'IncomeTaxPaymentConfig' } | { __typename?: 'IndividualPersonalAccount' } | { __typename?: 'InferredField' } | { __typename?: 'InferredFieldEvidence' } | { __typename?: 'InsightsTemplateBundleConfiguration' } | { __typename?: 'InsurancePersonalAccount' } | { __typename?: 'InsurancePolicy' } | { __typename?: 'InsurancePremiumPayment' } | { __typename?: 'IntegrationAssetClass' } | { __typename?: 'IntegrationCashflow' } | { __typename?: 'IntegrationClient' } | { __typename?: 'IntegrationConfiguration' } | { __typename?: 'IntegrationEntity' } | { __typename?: 'IntegrationInsurance' } | { __typename?: 'IntegrationLiability' } | { __typename?: 'IntegrationPerson' } | { __typename?: 'IrrevocableTrust' } | { __typename?: 'JointPersonalAccount' } | { __typename?: 'KGNode' } | { __typename?: 'KGRelationship' } | { __typename?: 'KGRoot' } | { __typename?: 'KGV2Document' } | { __typename?: 'KGV2DocumentChange' } | { __typename?: 'KGV2DocumentModification' } | { __typename?: 'KGV2Graph' } | { __typename?: 'KGV2Node' } | { __typename?: 'KGV2NodeAlias' } | { __typename?: 'KGV2NodeEvidence' } | { __typename?: 'KGV2Statement' } | { __typename?: 'KGV2StatementEvidence' } | { __typename?: 'KGV2StatementSupersession' } | { __typename?: 'KeyPerson' } | { __typename?: 'KeyPersonRole' } | { __typename?: 'LLCBusinessEntity' } | { __typename?: 'LPBusinessEntity' } | { __typename?: 'LiabilitiesBundleConfiguration' } | { __typename?: 'Liability' } | { __typename?: 'LiabilityPayment' } | { __typename?: 'LifeInsuranceBundleConfiguration' } | { __typename?: 'LifetimeExclusionEvent' } | { __typename?: 'LoggedTransfer' } | { __typename?: 'LuminaryOrganization' } | { __typename?: 'LuminaryTenantJIT' } | { __typename?: 'ManagedSFTPConnection' } | { __typename?: 'Memo' } | { __typename?: 'MemoPrompt' } | { __typename?: 'Message' } | { __typename?: 'MissingDocumentOverride' } | { __typename?: 'MissingDocumentsPage' } | { __typename?: 'ModelMapping' } | { __typename?: 'NotificationApp' } | { __typename?: 'NotificationPreference' } | { __typename?: 'OpenaiSdkConfig' } | { __typename?: 'OrganizationApplicationConfiguration' } | { __typename?: 'OrganizationDisclaimerConfiguration' } | { __typename?: 'OwnershipStake' } | { __typename?: 'PlatformDocument' } | { __typename?: 'PlatformFile' } | { __typename?: 'PlatformFilePage' } | { __typename?: 'PlatformFileParagraph' } | { __typename?: 'PresentationApprovalRequest' } | { __typename?: 'PresentationAssetDistributionBundleConfiguration' } | { __typename?: 'PresentationAssetDistributionItemConfiguration' } | { __typename?: 'PresentationAssetDistributionItemDetail' } | { __typename?: 'PresentationBundle' } | { __typename?: 'PresentationBundleCoverPage' } | { __typename?: 'PresentationBusinessOverviewBundleConfiguration' } | { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' } | { __typename?: 'PresentationBusinessOverviewItem' } | { __typename?: 'PresentationCoverPage' } | { __typename?: 'PresentationCoverSlideConfig' } | { __typename?: 'PresentationCustomPage' } | { __typename?: 'PresentationCustomPageBundleConfiguration' } | { __typename?: 'PresentationDiagramPage' } | { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' } | { __typename?: 'PresentationDocumentsReviewedDocument' } | { __typename?: 'PresentationFamilyOverviewBundleConfiguration' } | { __typename?: 'PresentationFamilyOverviewMemberConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveItem' } | { __typename?: 'PresentationItemCitation' } | { __typename?: 'PresentationPage' } | { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' } | { __typename?: 'PresentationPlanningOpportunitiesItem' } | { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyItem' } | { __typename?: 'PresentationTemplate' } | { __typename?: 'PresentationTemplateBundle' } | { __typename?: 'PresentationTemplateCoverPage' } | { __typename?: 'PresentationTemplateCustomPage' } | { __typename?: 'PresentationTemplateDiagramPage' } | { __typename?: 'PresentationTemplatePage' } | { __typename?: 'PresentationTrustOverviewBundleConfiguration' } | { __typename?: 'PresentationTrustOverviewItem' } | { __typename?: 'PresentationTrustOverviewTrustConfiguration' } | { __typename?: 'PresentationWillBundleConfiguration' } | { __typename?: 'PresentationWillClientConfiguration' } | { __typename?: 'PresentationWillItem' } | { __typename?: 'Principal' } | { __typename?: 'PrivateFoundation' } | { __typename?: 'ProfessionalTeamRole' } | { __typename?: 'Proposal' } | { __typename?: 'ProposalScenario' } | { __typename?: 'QPRTTrust' } | { __typename?: 'QualifiedTuitionPersonalAccount' } | { __typename?: 'ReleaseGroup' } | { __typename?: 'ReminderEmailNotificationRecord' } | { __typename?: 'RetirementPersonalAccount' } | { __typename?: 'RevocableTrust' } | { __typename?: 'Role' } | { __typename?: 'SCorpBusinessEntity' } | { __typename?: 'SLATTrust' } | { __typename?: 'SSOConnection' } | { __typename?: 'SalesforceExportAttempt' } | { __typename?: 'ScheduledDistribution' } | { __typename?: 'SoleProprietorshipBusinessEntity' } | { __typename?: 'SubBrand' } | { __typename?: 'SubBrandDisclaimerConfiguration' } | { __typename?: 'Submission' } | { __typename?: 'TaxDragConfig' } | { __typename?: 'TaxDragOverride' } | { __typename?: 'Team' } | { __typename?: 'Tenant' } | { __typename?: 'TenantApplicationConfiguration' } | { __typename?: 'TenantBranding' } | { __typename?: 'TenantDisclaimerConfiguration' } | { __typename?: 'TenantDocument' } | { __typename?: 'TenantReminderEmailsConfiguration' } | { __typename?: 'TenantSSOConnection' } | { __typename?: 'TenantSecurityConfiguration' } | { __typename?: 'TenantSlideConfig' } | { __typename?: 'TestCMKEncryption' } | { __typename?: 'TestamentaryEntity' } | { __typename?: 'TrustAdvisor' } | { __typename?: 'TrustAdvisorRole' } | { __typename?: 'Trustee' } | { __typename?: 'TrusteeDuty' } | { __typename?: 'User' } | { __typename?: 'UserFeedback' } | { __typename?: 'UserNotificationConfiguration' } | { __typename?: 'WaterfallBundleConfiguration' } | { __typename?: 'WaterfallBundleCoverPage' } | { __typename?: 'WaterfallComparisonBundleConfiguration' } | { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' } | { __typename?: 'WaterfallTemplateBundleConfiguration' } | { __typename?: 'WorkOSOrganization' } | { __typename?: 'WorkOSOrganizationDomain' } | { __typename?: 'WorkflowTracker' } | null, balanceSheetCategories: { __typename?: 'BalanceSheetCategoryConnection', edges?: Array<{ __typename?: 'BalanceSheetCategoryEdge', node?: { __typename?: 'BalanceSheetCategory', id: string, displayName: string } | null } | null> | null } };

export const Operations = {
  Query: {
    FullScreenStructuredAssetsModal: 'FullScreenStructuredAssetsModal' as const
  },
  Fragment: {
    FullScreenStructuredAssetsModal_Entity: 'FullScreenStructuredAssetsModal_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const FullScreenStructuredAssetsModal_EntityFragmentDoc = gql`
    fragment FullScreenStructuredAssetsModal_Entity on Entity {
  id
  stage
  addeparLinkedToNongrantorEntity
  liquidityStatus
  showEntityNameOnBalanceSheet
  groupIntegrationAssetValues
  pauseIntegrationSync
  balanceSheetCategoryOverride {
    id
  }
  integrationEntities {
    id
    kind
    name
  }
  subtype {
    id
    taxDiscount
    designerAccount {
      ...StructuredAssetsSubform_Account
    }
    ... on CCorpBusinessEntity {
      enableRealTppTaxExposure
    }
    ... on SCorpBusinessEntity {
      enableRealTppTaxExposure
    }
    ... on LLCBusinessEntity {
      enableRealTppTaxExposure
    }
    ... on LPBusinessEntity {
      enableRealTppTaxExposure
    }
    ... on GPBusinessEntity {
      enableRealTppTaxExposure
    }
    ... on SoleProprietorshipBusinessEntity {
      enableRealTppTaxExposure
    }
    ... on IndividualPersonalAccount {
      owner {
        id
        individual {
          id
        }
      }
    }
    ... on RetirementPersonalAccount {
      owner {
        id
        individual {
          id
        }
      }
    }
    ... on CustodialPersonalAccount {
      owner {
        id
        individual {
          id
        }
      }
    }
    ... on QualifiedTuitionPersonalAccount {
      owner {
        id
        individual {
          id
        }
      }
    }
    ... on JointPersonalAccount {
      owners {
        id
        individual {
          id
        }
      }
    }
    ... on InsurancePersonalAccount {
      owners {
        id
        individual {
          id
        }
      }
    }
    ... on GRATTrust {
      grantor {
        id
        individual {
          id
        }
      }
    }
    ... on SLATTrust {
      grantor {
        id
        individual {
          id
        }
      }
    }
    ... on IrrevocableTrust {
      grantors {
        id
        individual {
          id
        }
      }
    }
    ... on RevocableTrust {
      grantors {
        id
        individual {
          id
        }
      }
    }
    ... on ILITTrust {
      grantors {
        id
        individual {
          id
        }
      }
    }
    ... on QPRTTrust {
      grantors {
        id
        individual {
          id
        }
      }
    }
    ... on CRTTrust {
      grantors {
        id
        individual {
          id
        }
      }
    }
    ... on CLTTrust {
      grantors {
        id
        individual {
          id
        }
      }
    }
    ... on DonorAdvisedFund {
      donors {
        id
        individual {
          id
        }
      }
    }
    ... on PrivateFoundation {
      donors {
        id
        individual {
          id
        }
      }
    }
  }
}
    ${StructuredAssetsSubform_AccountFragmentDoc}`;
export const FullScreenStructuredAssetsModalDocument = gql`
    query FullScreenStructuredAssetsModal($entityId: ID!) {
  node(id: $entityId) {
    ... on Entity {
      ...FullScreenStructuredAssetsModal_Entity
    }
  }
  balanceSheetCategories(where: {type: ASSET}) {
    edges {
      node {
        id
        displayName
      }
    }
  }
}
    ${FullScreenStructuredAssetsModal_EntityFragmentDoc}`;

/**
 * __useFullScreenStructuredAssetsModalQuery__
 *
 * To run a query within a React component, call `useFullScreenStructuredAssetsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullScreenStructuredAssetsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullScreenStructuredAssetsModalQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useFullScreenStructuredAssetsModalQuery(baseOptions: Apollo.QueryHookOptions<FullScreenStructuredAssetsModalQuery, FullScreenStructuredAssetsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullScreenStructuredAssetsModalQuery, FullScreenStructuredAssetsModalQueryVariables>(FullScreenStructuredAssetsModalDocument, withFetchPolicyContext(options));
      }
export function useFullScreenStructuredAssetsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullScreenStructuredAssetsModalQuery, FullScreenStructuredAssetsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullScreenStructuredAssetsModalQuery, FullScreenStructuredAssetsModalQueryVariables>(FullScreenStructuredAssetsModalDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFullScreenStructuredAssetsModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FullScreenStructuredAssetsModalQuery, FullScreenStructuredAssetsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FullScreenStructuredAssetsModalQuery, FullScreenStructuredAssetsModalQueryVariables>(FullScreenStructuredAssetsModalDocument, withFetchPolicyContext(options));
        }
export type FullScreenStructuredAssetsModalQueryHookResult = ReturnType<typeof useFullScreenStructuredAssetsModalQuery>;
export type FullScreenStructuredAssetsModalLazyQueryHookResult = ReturnType<typeof useFullScreenStructuredAssetsModalLazyQuery>;
export type FullScreenStructuredAssetsModalSuspenseQueryHookResult = ReturnType<typeof useFullScreenStructuredAssetsModalSuspenseQuery>;
export type FullScreenStructuredAssetsModalQueryResult = Apollo.QueryResult<FullScreenStructuredAssetsModalQuery, FullScreenStructuredAssetsModalQueryVariables>;